import React, { createContext, useContext, useState } from 'react';
import { NOTIFICATION_DURATION } from '../config/appConfig';

const NotificationContext = createContext();

let idCounter = 0;

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const remove = (id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  const push = (type, message, opts = {}) => {
    const id = ++idCounter;
    const duration = opts.duration || NOTIFICATION_DURATION[type] || 4000;
    setNotifications((prev) => [...prev, { id, type, message, title: opts.title }]);
    if (duration > 0) {
      setTimeout(() => remove(id), duration);
    }
    return id;
  };

  const notify = {
    success: (msg, opts) => push('success', msg, opts),
    error:   (msg, opts) => push('error',   msg, opts),
    info:    (msg, opts) => push('info',    msg, opts),
    warning: (msg, opts) => push('warning', msg, opts),
    dismiss: remove
  };

  return (
    <NotificationContext.Provider value={{ notifications, notify, remove }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotify = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error('useNotify must be inside NotificationProvider');
  return ctx.notify;
};

export const useNotifications = () => {
  const ctx = useContext(NotificationContext);
  return ctx;
};
